import { Icon } from 'components/Icon/Icon'
import { ReactNode, useEffect } from 'react'
import styles from './ModalPage.module.scss'

type Props = {
    children: ReactNode,
    onClose?: () => void,
    hideCross: boolean,
}

export function ModalPage(props: Props) {

    useEffect(() => {
        // Отключаем прокрутку при открытии модального окна
        document.body.style.overflow = 'hidden';

        // Восстанавливаем прокрутку при закрытии модального окна
        return () => {
            document.body.style.overflow = '';
        };
    }, [])

    return (
        <div className={styles['modal']}>
            {!props.hideCross && (
                <div className={styles['modal__navbar']}>
                    <div className={styles['cross']} onClick={props.onClose}>
                        <Icon name='cross' />
                    </div>
                </div>
            )}
            <div className={styles['wrapper']}>
                <div className={styles['form']}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

ModalPage.defaultProps = {
    hideCross: false
};

